/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import React from 'react';
import { View } from 'app/scripts/views/internal/view';
import { DowngradePeriodBanner } from 'app/scripts/views/board-limits/DowngradePeriodBanner';
import { renderComponent } from 'app/src/components/ComponentWrapper';

export class DowngradePeriodBannerView extends View {
  constructor(options) {
    super(options);
    this.setShown = this.setShown.bind(this);
    this.isShown = this.isShown.bind(this);
  }

  initialize(model, modelCache) {
    if (this.$reactRoot == null) {
      this.$reactRoot = $('<div></div>');
    }
    return (this.bannerState = false);
  }

  setShown(bannerShown) {
    return (this.bannerState = bannerShown);
  }

  isShown() {
    return this.bannerState;
  }

  remove() {
    this.unmountBanner();
  }

  render() {
    this.$el.append(this.$reactRoot);

    this.unmountBanner = renderComponent(
      <DowngradePeriodBanner
        model={this.model}
        modelCache={this.modelCache}
        setShown={this.setShown}
      />,
      this.$reactRoot[0],
    );
    return this;
  }
}
